import type { Category, Site, Topic } from '@/types/nav';

export const categories: Category[] = [
  {
    slug: 'news',
    label: '新闻资讯',
    icon: 'ri-newspaper-line',
    description: '聚合时政、财经与科技资讯，快速掌握每日热点动态。',
    subCategories: ['综合新闻', '财经资讯', '科技前沿', '地方新闻'],
  },
  {
    slug: 'video',
    label: '视频娱乐',
    icon: 'ri-play-circle-line',
    description: '覆盖长视频、短视频与音乐直播，随时开启娱乐时光。',
    subCategories: ['长视频', '短视频', '音乐直播'],
  },
  {
    slug: 'shopping',
    label: '购物电商',
    icon: 'ri-shopping-bag-3-line',
    description: '综合电商、特卖折扣与数码家电，一键直达优惠好物。',
    subCategories: ['综合电商', '特卖折扣', '数码家电', '生鲜超市'],
  },
  {
    slug: 'social',
    label: '社交互动',
    icon: 'ri-chat-smile-2-line',
    description: '社交平台、问答与兴趣社区，连接同好与真实观点。',
    subCategories: ['社交平台', '问答社区', '兴趣社区', '职场社交'],
  },
  {
    slug: 'tools',
    label: '工具效率',
    icon: 'ri-tools-line',
    description: '搜索、出行、办公与生活服务工具，让日常更高效。',
    subCategories: ['搜索工具', '出行服务', '办公协作', '生活服务'],
  },
  {
    slug: 'education',
    label: '学习教育',
    icon: 'ri-book-open-line',
    description: '在线课程、语言学习与考试辅导，随时随地给自己充电。',
    subCategories: ['在线课程', '语言学习', '考试辅导', '知识付费'],
  },
];

export const sites: Site[] = [
  // 新闻资讯
  {
    id: 'people',
    name: '人民网',
    url: 'http://www.people.com.cn',
    description: '权威综合新闻门户，聚焦时政要闻与民生热点报道。',
    category: 'news',
    subCategory: '综合新闻',
    hot: 9820,
    region: '全国',
    tags: ['权威', '时政', '综合'],
    addedAt: '2026-09-18',
    theme: 'primary',
    initial: '人',
    featured: true,
  },
  {
    id: 'xinhuanet',
    name: '新华网',
    url: 'http://www.xinhuanet.com',
    description: '国家通讯社旗下门户，提供国内外权威新闻资讯。',
    category: 'news',
    subCategory: '综合新闻',
    hot: 9650,
    region: '全国',
    tags: ['权威', '国际', '综合'],
    addedAt: '2026-09-16',
    theme: 'secondary',
    initial: '新',
  },
  {
    id: 'thepaper',
    name: '澎湃新闻',
    url: 'https://www.thepaper.cn',
    description: '专注深度报道与原创时政，追问事实真相。',
    category: 'news',
    subCategory: '综合新闻',
    hot: 9430,
    region: '全国',
    tags: ['深度', '时政', '原创'],
    addedAt: '2026-10-02',
    theme: 'accent',
    initial: '澎',
  },
  {
    id: 'toutiao',
    name: '今日头条',
    url: 'https://www.toutiao.com',
    description: '个性化资讯推荐平台，海量内容按兴趣智能分发。',
    category: 'news',
    subCategory: '综合新闻',
    hot: 9900,
    region: '全国',
    tags: ['资讯', '推荐', '热点'],
    addedAt: '2026-08-29',
    theme: 'primary',
    initial: '头',
    featured: true,
  },
  {
    id: 'news-qq',
    name: '腾讯新闻',
    url: 'https://blwang51.asia',
    description: '综合资讯门户，覆盖社会、娱乐与体育多领域新闻。',
    category: 'news',
    subCategory: '综合新闻',
    hot: 9310,
    region: '全国',
    tags: ['门户', '综合', '热点'],
    addedAt: '2026-09-05',
    theme: 'accent',
    initial: '腾',
  },
  {
    id: '36kr',
    name: '36氪',
    url: 'https://36kr.com',
    description: '创投与科技商业媒体，关注新经济公司动态。',
    category: 'news',
    subCategory: '科技前沿',
    hot: 8760,
    region: '全国',
    tags: ['科技', '创业', '投资'],
    addedAt: '2026-10-08',
    theme: 'primary',
    initial: '氪',
  },

  // 视频娱乐
  {
    id: 'bilibili',
    name: '哔哩哔哩',
    url: 'https://www.bilibili.com',
    description: '年轻人聚集的兴趣视频社区，弹幕互动氛围浓厚。',
    category: 'video',
    subCategory: '长视频',
    hot: 9960,
    region: '全国',
    tags: ['弹幕', '二次元', '社区'],
    addedAt: '2026-09-28',
    theme: 'primary',
    initial: '哔',
    featured: true,
  },
  {
    id: 'v-qq',
    name: '腾讯视频',
    url: 'https://blwang51.asia',
    description: '海量影视综艺剧集，热门独播内容一站观看。',
    category: 'video',
    subCategory: '长视频',
    hot: 9650,
    region: '全国',
    tags: ['影视', '综艺', '独播'],
    addedAt: '2026-09-10',
    theme: 'accent',
    initial: '腾',
  },
  {
    id: 'iqiyi',
    name: '爱奇艺',
    url: 'https://www.iqiyi.com',
    description: '自制剧与综艺内容丰富，会员专享高清体验。',
    category: 'video',
    subCategory: '长视频',
    hot: 9580,
    region: '全国',
    tags: ['影视', '自制剧', '会员'],
    addedAt: '2026-09-22',
    theme: 'secondary',
    initial: '爱',
  },
  {
    id: 'douyin',
    name: '抖音',
    url: 'https://www.douyin.com',
    description: '全民短视频平台，记录分享美好生活的热门阵地。',
    category: 'video',
    subCategory: '短视频',
    hot: 9930,
    region: '全国',
    tags: ['短视频', '直播', '热门'],
    addedAt: '2026-08-21',
    theme: 'foreground',
    initial: '抖',
    featured: true,
  },
  {
    id: 'kuaishou',
    name: '快手',
    url: 'https://www.kuaishou.com',
    description: '记录与分享生活的短视频社区，直播电商活跃。',
    category: 'video',
    subCategory: '短视频',
    hot: 9540,
    region: '全国',
    tags: ['短视频', '直播', '电商'],
    addedAt: '2026-09-30',
    theme: 'accent',
    initial: '快',
  },
  {
    id: 'music-163',
    name: '网易云音乐',
    url: 'https://music.163.com',
    description: '主打歌单与乐评的音乐平台，发现你的专属音乐。',
    category: 'video',
    subCategory: '音乐直播',
    hot: 9180,
    region: '全国',
    tags: ['音乐', '歌单', '乐评'],
    addedAt: '2026-10-04',
    theme: 'primary',
    initial: '网',
  },

  // 购物电商
  {
    id: 'taobao',
    name: '淘宝',
    url: 'https://www.taobao.com',
    description: '综合电商平台，海量商品与店铺覆盖生活全场景。',
    category: 'shopping',
    subCategory: '综合电商',
    hot: 9980,
    region: '全国',
    tags: ['综合', '海量', '购物'],
    addedAt: '2026-08-15',
    theme: 'accent',
    initial: '淘',
    featured: true,
  },
  {
    id: 'jd',
    name: '京东',
    url: 'https://www.jd.com',
    description: '以自营和物流见长的综合电商，正品与时效兼具。',
    category: 'shopping',
    subCategory: '综合电商',
    hot: 9890,
    region: '全国',
    tags: ['自营', '物流', '正品'],
    addedAt: '2026-09-01',
    theme: 'primary',
    initial: '京',
    featured: true,
  },
  {
    id: 'pinduoduo',
    name: '拼多多',
    url: 'https://www.pinduoduo.com',
    description: '拼团购物平台，以高性价比商品广受欢迎。',
    category: 'shopping',
    subCategory: '综合电商',
    hot: 9810,
    region: '全国',
    tags: ['拼团', '低价', '实惠'],
    addedAt: '2026-09-12',
    theme: 'secondary',
    initial: '拼',
  },
  {
    id: 'tmall',
    name: '天猫',
    url: 'https://www.tmall.com',
    description: '品牌旗舰店聚集地，正品保障与新品首发优选。',
    category: 'shopping',
    subCategory: '综合电商',
    hot: 9700,
    region: '全国',
    tags: ['品牌', '旗舰店', '正品'],
    addedAt: '2026-09-20',
    theme: 'accent',
    initial: '天',
  },
  {
    id: 'vip',
    name: '唯品会',
    url: 'https://www.vip.com',
    description: '品牌特卖折扣平台，服饰美妆好货限时优惠。',
    category: 'shopping',
    subCategory: '特卖折扣',
    hot: 8720,
    region: '全国',
    tags: ['特卖', '折扣', '服饰'],
    addedAt: '2026-10-06',
    theme: 'primary',
    initial: '唯',
  },
  {
    id: 'smzdm',
    name: '什么值得买',
    url: 'https://www.smzdm.com',
    description: '消费决策导购平台，比价与优惠信息一网打尽。',
    category: 'shopping',
    subCategory: '特卖折扣',
    hot: 8640,
    region: '全国',
    tags: ['导购', '比价', '优惠'],
    addedAt: '2026-10-10',
    theme: 'primary',
    initial: '值',
  },

  // 社交互动
  {
    id: 'weibo',
    name: '微博',
    url: 'https://weibo.com',
    description: '开放式社交平台，热搜与广场汇聚全网热点话题。',
    category: 'social',
    subCategory: '社交平台',
    hot: 9910,
    region: '全国',
    tags: ['热搜', '广场', '话题'],
    addedAt: '2026-08-18',
    theme: 'accent',
    initial: '微',
    featured: true,
  },
  {
    id: 'zhihu',
    name: '知乎',
    url: 'https://www.zhihu.com',
    description: '高质量的问答社区，专业见解与经验分享聚集地。',
    category: 'social',
    subCategory: '问答社区',
    hot: 9720,
    region: '全国',
    tags: ['问答', '知识', '社区'],
    addedAt: '2026-09-08',
    theme: 'primary',
    initial: '知',
  },
  {
    id: 'douban',
    name: '豆瓣',
    url: 'https://www.douban.com',
    description: '书影音兴趣社区，评分与小组讨论记录文化生活。',
    category: 'social',
    subCategory: '兴趣社区',
    hot: 9080,
    region: '全国',
    tags: ['书影音', '小组', '评分'],
    addedAt: '2026-09-25',
    theme: 'secondary',
    initial: '豆',
  },
  {
    id: 'xiaohongshu',
    name: '小红书',
    url: 'https://www.xiaohongshu.com',
    description: '生活方式分享社区，种草笔记与真实体验汇聚。',
    category: 'social',
    subCategory: '社交平台',
    hot: 9860,
    region: '全国',
    tags: ['种草', '笔记', '生活'],
    addedAt: '2026-09-02',
    theme: 'accent',
    initial: '小',
    featured: true,
  },
  {
    id: 'tieba',
    name: '百度贴吧',
    url: 'https://tieba.baidu.com',
    description: '基于兴趣的主题论坛，聚集同好交流讨论。',
    category: 'social',
    subCategory: '兴趣社区',
    hot: 8620,
    region: '全国',
    tags: ['论坛', '兴趣', '交流'],
    addedAt: '2026-10-01',
    theme: 'primary',
    initial: '贴',
  },
  {
    id: 'maimai',
    name: '脉脉',
    url: 'https://maimai.cn',
    description: '职场社交平台，拓展人脉与了解行业动态。',
    category: 'social',
    subCategory: '职场社交',
    hot: 7860,
    region: '全国',
    tags: ['职场', '人脉', '行业'],
    addedAt: '2026-10-12',
    theme: 'secondary',
    initial: '脉',
  },

  // 工具效率
  {
    id: 'baidu',
    name: '百度',
    url: 'https://www.baidu.com',
    description: '中文搜索引擎，快速检索网页、图片与资讯。',
    category: 'tools',
    subCategory: '搜索工具',
    hot: 9990,
    region: '全国',
    tags: ['搜索', '资讯', '问答'],
    addedAt: '2026-08-10',
    theme: 'primary',
    initial: '百',
    featured: true,
  },
  {
    id: 'amap',
    name: '高德地图',
    url: 'https://www.amap.com',
    description: '专业地图导航服务，实时路况与出行路线规划。',
    category: 'tools',
    subCategory: '出行服务',
    hot: 9360,
    region: '全国',
    tags: ['地图', '导航', '路况'],
    addedAt: '2026-09-14',
    theme: 'accent',
    initial: '高',
  },
  {
    id: 'rail12306',
    name: '铁路12306',
    url: 'https://www.12306.cn',
    description: '官方火车票购票平台，查询与预订列车车票。',
    category: 'tools',
    subCategory: '出行服务',
    hot: 9480,
    region: '全国',
    tags: ['火车票', '出行', '官方'],
    addedAt: '2026-09-19',
    theme: 'secondary',
    initial: '铁',
    featured: true,
  },
  {
    id: 'alipay',
    name: '支付宝',
    url: 'https://www.alipay.com',
    description: '数字生活服务平台，支付、缴费与政务办事一站完成。',
    category: 'tools',
    subCategory: '生活服务',
    hot: 9760,
    region: '全国',
    tags: ['支付', '生活', '服务'],
    addedAt: '2026-08-25',
    theme: 'primary',
    initial: '支',
  },
  {
    id: 'docs-qq',
    name: '腾讯文档',
    url: 'https://blwang51.asia',
    description: '在线协同文档工具，多人实时编辑与模板丰富。',
    category: 'tools',
    subCategory: '办公协作',
    hot: 8580,
    region: '全国',
    tags: ['文档', '协作', '在线'],
    addedAt: '2026-10-07',
    theme: 'accent',
    initial: '文',
  },
  {
    id: 'meituan',
    name: '美团',
    url: 'https://www.meituan.com',
    description: '本地生活服务平台，外卖到店与酒店旅行全覆盖。',
    category: 'tools',
    subCategory: '生活服务',
    hot: 9620,
    region: '全国',
    tags: ['外卖', '到店', '生活'],
    addedAt: '2026-09-06',
    theme: 'accent',
    initial: '美',
  },

  // 学习教育
  {
    id: 'icourse163',
    name: '中国大学MOOC',
    url: 'https://www.icourse163.org',
    description: '汇聚高校优质课程，免费学习名校名师公开课。',
    category: 'education',
    subCategory: '在线课程',
    hot: 8720,
    region: '全国',
    tags: ['高校', '课程', '免费'],
    addedAt: '2026-09-26',
    theme: 'primary',
    initial: 'M',
  },
  {
    id: 'open-163',
    name: '网易公开课',
    url: 'https://open.163.com',
    description: '国内外名校公开课与TED演讲，通识学习平台。',
    category: 'education',
    subCategory: '在线课程',
    hot: 8340,
    region: '全国',
    tags: ['公开课', '通识', '演讲'],
    addedAt: '2026-10-03',
    theme: 'secondary',
    initial: '网',
  },
  {
    id: 'dedao',
    name: '得到',
    url: 'https://www.dedao.cn',
    description: '知识付费与通识课程平台，系统化学习各种知识。',
    category: 'education',
    subCategory: '知识付费',
    hot: 8460,
    region: '全国',
    tags: ['知识付费', '课程', '通识'],
    addedAt: '2026-10-09',
    theme: 'accent',
    initial: '得',
  },
  {
    id: 'shanbay',
    name: '扇贝单词',
    url: 'https://www.shanbay.com',
    description: '英语单词学习工具，科学背诵与打卡记单词。',
    category: 'education',
    subCategory: '语言学习',
    hot: 7980,
    region: '全国',
    tags: ['英语', '背单词', '打卡'],
    addedAt: '2026-10-11',
    theme: 'primary',
    initial: '扇',
  },
  {
    id: 'duolingo',
    name: '多邻国',
    url: 'https://www.duolingo.com',
    description: '趣味化多语言学习平台，游戏化方式轻松入门。',
    category: 'education',
    subCategory: '语言学习',
    hot: 8620,
    region: '海外',
    tags: ['多语言', '趣味', '入门'],
    addedAt: '2026-09-29',
    theme: 'secondary',
    initial: '多',
  },
  {
    id: 'zuoyebang',
    name: '作业帮',
    url: 'https://www.zuoyebang.com',
    description: '中小学在线学习平台，拍照搜题与名师辅导。',
    category: 'education',
    subCategory: '考试辅导',
    hot: 8180,
    region: '全国',
    tags: ['中小学', '搜题', '辅导'],
    addedAt: '2026-10-05',
    theme: 'accent',
    initial: '作',
  },
];

export const topics: Topic[] = [
  {
    id: 'discount',
    title: '购物优惠专区',
    description: '精选综合电商与特卖折扣平台，一键直达高性价比好物。',
    image: 'https://readdy.ai/api/search-image?query=abstract%20minimal%20e-commerce%20shopping%20concept%20with%20warm%20orange%20tones%2C%20floating%20paper%20shopping%20bags%20and%20soft%20geometric%20shapes%2C%20clean%20bright%20studio%20background%2C%20editorial%20illustration%2C%20harmonious%20composition&width=800&height=520&seq=nav-topic-discount-01&orientation=landscape',
    siteIds: ['taobao', 'jd', 'pinduoduo', 'tmall', 'vip', 'smzdm'],
  },
  {
    id: 'social',
    title: '热门社交平台',
    description: '聚合社交、问答与兴趣社区，连接同好并发现真实观点。',
    image: 'https://readdy.ai/api/search-image?query=abstract%20minimal%20social%20network%20connection%20concept%2C%20interconnected%20round%20nodes%20and%20soft%20lines%2C%20fresh%20green%20and%20neutral%20tones%2C%20clean%20bright%20studio%20background%2C%20modern%20editorial%20illustration&width=800&height=520&seq=nav-topic-social-01&orientation=landscape',
    siteIds: ['weibo', 'zhihu', 'xiaohongshu', 'douban', 'tieba'],
  },
  {
    id: 'learn',
    title: '学习充电站',
    description: '在线课程与语言学习平台集合，随时给自己充充电。',
    image: 'https://readdy.ai/api/search-image?query=abstract%20minimal%20online%20learning%20concept%20with%20soft%20blue%20tones%2C%20floating%20books%20and%20open%20pages%20geometric%20shapes%2C%20clean%20bright%20studio%20background%2C%20modern%20editorial%20illustration&width=800&height=520&seq=nav-topic-learn-01&orientation=landscape',
    siteIds: ['icourse163', 'open-163', 'dedao', 'shanbay', 'duolingo'],
  },
];